import { render, staticRenderFns } from "./TemWaterAlarmSet.vue?vue&type=template&id=87f7aaa4&scoped=true"
import script from "./TemWaterAlarmSet.vue?vue&type=script&lang=js"
export * from "./TemWaterAlarmSet.vue?vue&type=script&lang=js"
import style0 from "./TemWaterAlarmSet.vue?vue&type=style&index=0&id=87f7aaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f7aaa4",
  null
  
)

export default component.exports